<script>
import formInput from "@/mixins/shared/formInput";
import InputText from '@/pages/components/form/input-only/input.vue';

export default {
	components: {InputText},
	mixins: [formInput],
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		}
	},
}
</script>

<template>
	<div class="input-group">
		<span class="input-group-text">
			<input
				:name="name"
				v-bind="$attrs"
				@input="changeModelValue"
				type="color"
				:id="renderedId"
				:value="modelValue"
				class="form-control-color"
			/>
		</span>
		<input
			:name="name"
			v-bind="$attrs"
			@input="changeModelValue"
			type="text"
			:id="renderedId"
			:class="{'form-control': true, 'border-danger': hasError}"
			:value="modelValue"
			pattern="#([0-9a-fA-F]{3}){1,2}"
			placeholder="#000000"
		>
		<span class="input-group-text" v-if="$slots.addonafter">
			<slot name="addonafter"/>
		</span>
	</div>

	<div v-if="$slots.descriptionbottom" class="input-description mt-2">
		<slot name="descriptionbottom"/>
	</div>

	<label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
</template>